import React from "react";
import Hero from "../components/Hero";
import Cards from "../components/Cards";

const Home = () => {
  return (
    <div>
      <Hero />
      <Cards />
    </div>
  );
};

export default Home;
